import { useAppScopeStore } from '@frontend/scope';
import { PaymentSettingsGroup } from '../atoms/payment-settings-group';
import { PaymentSettingsCard } from '../atoms/payments-card';
import { JustifiOnboardingForm } from '../sections/justifi-onboarding-form';

export const JustifiSettingsGroup = () => {
  const { selectedLocationIds: locationIds } = useAppScopeStore();
  return (
    <section>
      {locationIds.length === 1 ? (
        <PaymentSettingsCard locationId={locationIds[0]}>
          <JustifiOnboardingForm />
        </PaymentSettingsCard>
      ) : (
        <PaymentSettingsGroup includeNonPaymentLocations>
          <JustifiOnboardingForm />
        </PaymentSettingsGroup>
      )}
    </section>
  );
};
